import { Component, type ReactNode } from 'react';
import { AlertTriangle } from 'lucide-react';

interface State { error: Error | null }

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    console.error('UI error boundary:', error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          role="alert"
          className="min-h-screen grid place-items-center p-6"
        >
          <div className="card p-6 max-w-md text-center">
            <AlertTriangle className="h-8 w-8 text-destructive mx-auto mb-3" aria-hidden="true" />
            <h1 className="text-lg font-semibold mb-1">Something went wrong</h1>
            <p className="text-sm text-muted-foreground mb-4">
              {this.state.error.message || 'An unexpected error occurred.'}
            </p>
            <button
              className="btn-primary"
              onClick={() => { this.setState({ error: null }); location.reload(); }}
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
